import startupThumbnail from 'images/areas/areas-startup-circle.png';
import guardianshipThumbnail from 'images/areas/areas-guardianship-circle.png';
import affordableHousingThumbnail from 'images/areas/areas-affordable-housing-circle.png';
import nonprofitThumbnail from 'images/areas/areas-nonprofit-circle.png';
import realEstateThumbnail from 'images/areas/areas-real-estate-circle.png';
import willThumbnail from 'images/areas/areas-will-circle.png';
import probateThumbnail from 'images/areas/areas-probate-circle.png';

export default {
  nav: {
    items: [
      {
        label: 'How I can help',
        path: '/areas'
      },
      {
        label: 'About',
        path: '/about'
      },
      {
        label: 'Testimonials', 
        path: '/testimonials'
      },
      {
        label: 'Payment & Contact',
        path: '/payment-contact'
      }
    ]
  },
  areas: [
    {
      label: 'Wills, Trusts & Succession Planning',
      thumbnailSrc: willThumbnail,
      summary: 'I can help with succession planning for you or your business, whether you have a complex estate or are just starting a family.  You can prevent unnecessary hardships for your loved ones with a practical plan tailored to your needs.'
    },
    {
      label: 'Business Formation',
      thumbnailSrc: startupThumbnail,
      summary: 'I can help you decide on the best type of new business entity for your situation – S Corporation, C Corporation, Limited Liability Company (LLC), Limited Partnership, General Partnership, Limited Liability Partnership, or Professional Corporation – properly document and form the new organization and help you plan for ongoing compliance and reporting requirements.'

    },
    {
      label: 'Probate & Ancillary Probate',
      thumbnailSrc: probateThumbnail,
      summary: 'I can assist you with probate matters in Oklahoma, whether general or ancillary.  The process of probating a will or an intestate estate is complex and requires an experienced attorney to ensure that all notices and publications have been timely and properly given, all inventories and accountings are properly prepared and filed, and all claims evaluated and allowed or denied.  I can guide and represent you through this process.'
    },
    {
      label: 'Guardianship',
      thumbnailSrc: guardianshipThumbnail,
      summary: 'Sometimes it is necessary to seek court appointment of a guardian or conservator for a child or an incapacitated adult.  For example, this can happen due to the death of one or both parents of a minor child or the illness or injury of an adult.  I can guide and represent you through this complex process.'
    },
    {
      label: 'Real Estate Transactions',
      thumbnailSrc: realEstateThumbnail,
      summary: 'I can assist you with your commercial real estate transaction – purchase and sale, refinance, or loan modification.  I can also advise and assist with your lease negotiation, modification or extension, SNDA (Subordination, Non-disturbance, and Attornment agreement), sublease, or assignment.'
    },
    {
      label: 'Nonprofits',
      thumbnailSrc: nonprofitThumbnail,
      summary: 'I can help you decide on the right form for your new nonprofit organization and guide you through qualifying for Recognition of Exemption with the IRS for 501(c)(3)s and other types of charities.  I can also help with governance and compliance issues for your existing nonprofit.'
    },
    {
      label: 'Affordable Housing',
      thumbnailSrc: affordableHousingThumbnail,
      summary: 'Land Use Restrction Agreements, Grant Applications, Community Housing Development Organization qualification, Fair Housing, etc.'
    }
  ],
  about: [
    'I grew up in a small town in the desert of southwest Texas, earned a Bachelor of Arts degree in English Literature from Baylor University in 1981, a Master of Arts degree in English Literature from Pittsburg State University in 1986, and a Juris Doctor degree (J.D.) from Oklahoma City University School of Law in 1985.',
    'I have been a member of the State Bar of Oklahoma since 1986 and have practiced law in Oklahoma in law firms practicing insurance defense, commercial litigation, employment and discrimination law, and commercial real estate.  I am admitted to practice in all Courts in and for the State of Oklahoma as well as the U.S. District Courts for the Eastern, Northern, and Western Districts of Oklahoma, and the 10th U.S. Circuit Court of Appeals.',
    'I have served as legal counsel to Preservation Freehold Company, an affordable housing nonprofit that helps develop affordable assisted living and senior care centers, since its formation in 2009, and I am a past member of the Board of Advisors of Turning Point Ministries, Inc., an affordable housing nonprofit serving Edmond, Oklahoma.',
    'From 1996 to 1998 I was a Barrister member of the William J.  Holloway American Inn of Court. I am a member of the Oklahoma Bar Association and its Estate Planning and Probate Section.'
  ],
  testimonials: [
    {
      author: 'Andrew, 5 stars (via Avvo)',
      text: ["Ben was wonderful. Took care of things in my probate matter I didn't even know needed take care of. Friendly and actually cares. i couldn't have made a better choice."]
    },
    {
      author: 'Tuck, 5 stars (via Avvo)',
      text: ["Ben helped my wife and I put together all the legal documentation needed in case anything happened to us. He was very helpful and patient with us – new parents who didn't quite understand all of the laws and details surrounding wills, living wills, etc. I would highly recommend Ben. He was very professional, friendly, meticulous and thorough."]
    },
    {
      author: 'Reid, 5 stars (via Avvo)',
      text: ["Ben helped my wife and I write up our will and testament. He was very professional and answered all of our questions and guided us through the difficult decisions required when writing up a last will and testimony."]
    },
    {
      author: 'Tom, 5 stars (via Avvo)',
      text: ["Ben has helped our non profit file corporate papers with the states and prepared our successful application for 501 (c)(3) status with the IRS. Then he represented the non profit is several real estate transactions including land acquisition, development and construction of low income housing and healthcare projects."]
    },
    {
      author: 'Avvo reviewer, 5 stars',
      text: ["Ben Meek provided my family with diverse counsel, including estate planning, incorporating and criminal defense. He consistently invested a great amount of time listening to me and my family members, exploring the important background with good questions, identifying our goals/needs. Then he built reasonable, exceptional expectations and exceeded them.","Ben offers me advice, both personally and professionally, and I count him among my closest advisors."]
    }
  ]
};



// WEBPACK FOOTER //
// ./app/data/site.js